import { Model } from '@/models/Model';
export class GroupType extends Model {
    constructor() {
        super(...arguments);
        this.$endpoint = '/group-types';
        this.$name = 'GroupType';
        this.$fillable = [];
    }
}
export var GroupTypeEnum;
(function (GroupTypeEnum) {
    GroupTypeEnum["CLASS"] = "class";
    GroupTypeEnum["FIXED"] = "fixed";
    GroupTypeEnum["COACH"] = "coach";
    GroupTypeEnum["PROJECT"] = "project";
    GroupTypeEnum["GROUPABLE"] = "groupable";
    GroupTypeEnum["PARNASSYS"] = "parnassys";
})(GroupTypeEnum || (GroupTypeEnum = {}));
